import { useNavigationStore } from "@/store/navigationStore";
import Lottie from "lottie-react";
import loading from "src/components/lottie/loading.json";


export default function LoadingMask() {
  const isLoading = useNavigationStore((state) => state.isLoading);

  if (!isLoading) return null;

  return isLoading ? (
    <div className="fixed inset-0 z-[60] flex items-center justify-center">
      <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center bg-white bg-opacity-80 "></div>
      <div className="h-25 w-25 flex items-center justify-center">
        <Lottie animationData={loading} loop={true} />
      </div>
    </div>
  ) : (
    <></>
  );
}